import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@atlaskit/modal-dialog';

import { messages } from './atlassian-intelligence.i18n';

export type AtlassianIntelligenceDeactivationModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

export function AtlassianIntelligenceDeactivationModal({
  onConfirm,
  onCancel,
  isLoading,
}: AtlassianIntelligenceDeactivationModalProps) {
  const intl = useIntl();

  return (
    <Modal
      onClose={() => {
        if (!isLoading) {
          onCancel();
        }
      }}
    >
      <ModalHeader>
        <ModalTitle appearance="warning">
          <FormattedMessage
            {...messages.atlassianIntelligenceDeactivateModalTitle}
          />
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <FormattedMessage
          {...messages.atlassianIntelligenceDeactivateModalDescription}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          appearance="subtle"
          onClick={onCancel}
          testId="cancel-button"
          isDisabled={isLoading}
        >
          {intl.formatMessage(messages.cancelButtonText)}
        </Button>
        <Button
          appearance="warning"
          onClick={onConfirm}
          autoFocus
          testId="confirm-button"
          isLoading={isLoading}
        >
          {intl.formatMessage(messages.confirmButtonText)}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
